import { z } from "zod";

export const artistTrackSchema = z.object({
  title: z.string(),
  subtitle: z.string(),
  imageUrl: z.string().nullish(),
  previewUrl: z.string().nullish(),
  spotifyTrackUri: z.string().nullish(),
  appleTrackUri: z.string().nullish(),
  genres: z.array(z.string()).nullish(),
});
